var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Table',{attrs:{"title":_vm.$t('table.title.categories'),"name":"Category","headers":_vm.headers,"items":_vm.categories,"loading":_vm.isLoading,"hidePagination":true,"newItem":false},on:{"refetch":_vm.handleCategoriesFetch}})
}
var staticRenderFns = []

export { render, staticRenderFns }